import { useEffect } from 'react';
import { SocketRoutes } from 'services/wsService';
import { useAppSelector } from 'store';

type RoomType =
  | 'smsDashboard'
  | 'smsDashboardUnregistered'
  | 'rpmDashboardSla'
  | 'rpmDashboard'
  | 'interactiveTimeAssign'
  | 'rpmPatientProfile';

declare global {
  interface Window {
    _websocket_rooms: Set<string>;
  }
}

window._websocket_rooms = window._websocket_rooms || new Set<string>();
const addRoom = (key: string) => window._websocket_rooms.add(key);
const removeRoom = (key: string) => window._websocket_rooms.delete(key);
const isRoomJoined = (key: string) => window._websocket_rooms.has(key);

interface IWSRoomOptions {
  patientGuid?: string;
  enabled?: boolean;
}
export const useWebsocketRoom = (
  room: RoomType,
  { patientGuid, enabled = true }: IWSRoomOptions = {},
) => {
  const socket = useAppSelector((state) => state.socket);

  useEffect(() => {
    if (!enabled) return;

    const key = `${room}-${patientGuid}`;
    if (socket.client && socket.isConnected && !isRoomJoined(key)) {
      socket.client.send(SocketRoutes.JoinToRoom, { room, patientGuid });
      addRoom(key);
    }
    if (!socket.isConnected) {
      removeRoom(key);
    }
  }, [socket.isConnected, patientGuid, enabled]);

  useEffect(() => {
    if (!enabled) return;

    return () => {
      const key = `${room}-${patientGuid}`;
      if (socket.client && socket.isConnected && isRoomJoined(key)) {
        socket.client.send(SocketRoutes.LeaveRoom, { room, patientGuid });
        removeRoom(key);
      }
    };
  }, [patientGuid, enabled]);
};
